module.exports = __webpack_public_path__ + "img/a2.d6ddb94a.png";